const home = {
	'home.usdt.title': 'USDT İstikrarlı Para Birimi',
	'home.usdt.title2': 'Cari gelir',
	'home.usdt.max': 'Maksimum',
	'home.usdt.balance': 'Bakiye',
	'home.usdt.total': 'Toplam mevduat',
	'home.total.balance': 'Akış havuzu',
	'home.btn.approve': 'Yetkilendirme',
	'home.btn.stake': 'Para Yatırma',
	'home.withdraw.title': 'Çekilebilir',
	'home.withdraw.2': 'Geri al',
	'home.withdraw.earnings': 'Kişisel gelir',
	'home.withdraw.amount': 'Ekolojik faydalar',
	'home.withdraw.btn1': 'Çek',
	'home.withdraw.btn2': 'Tekrar para yatır',
	'home.team.title': 'Toplam Ekosistem Mevduatı',
	'home.team.1': 'Adres',
	'home.team.upper': 'Tavsiye Eden',
	'home.team.address.placeholder': 'Lütfen kullanıcı adresini girin',
	'home.team.address.s': 'Bağlı',
	'home.team.leavel': 'Seviye',
	'home.team.bind': 'Bağla',
	'home.team.info': 'bilgi',
	'home.invite.title': 'Davet bağlantısı',
	'home.invite.copy': 'Kopyala',
	'home.invite.tip': 'Lütfen önce hesabınızı etkinleştirin',
	'home.message.tip0': 'Başarıyla alındı',
	'home.message.tip1': 'Yetkilendirme başarılı',
	'home.message.tip2': 'Para yatırma işlemi başarılı',
	'home.message.tip3': 'Minimum para yatırma tutarı: {{msg}} USDT',
	'home.message.tip4': 'Cari hesap bakiyesi: {{msg}} USDT',
	'home.message.tip5': 'Kopyalama başarılı',
	'home.message.tip6': 'Kendi adresinizi bağlayamazsınız',
	'home.message.tip7': 'Bağlama başarılı',
	'home.message.tip8': 'Kullanım başarılı',
	'home.message.tip9': 'Cari hesapta kullanılabilecek maksimum tutar: {{msg}} USDT',

	'home.check.order.title': 'Siparişi kontrol et',
	'home.2.stake.btn.1': 'Normal',
	'home.2.stake.btn.1.1': '(15 gün)',
	'home.2.stake.btn.2': 'geçerli',
	'home.2.stake.btn.3': 'Oran: {{msg}}%',

	'home.orders.title': 'Siparişlerim',
	'home.orders.tips1': 'Yatırılan tutar',
	'home.orders.tips2': 'Beklenen gelir',
	'home.orders.tips3': 'Para yatırma süresi',
	'home.orders.tips4': 'Son kullanma tarihi',
	'home.orders.tips5': 'Alındı',
	'home.orders.btn1': 'Anlayın',
	'home.orders.btn2': 'Alındı',
	'home.orders.no.more': 'Artık yok',
	'home.orders.claim.success': 'Başarıyla talep edildi',

	'home.2.withdraw.title': 'Bir sonraki çekime kadar geçen süre:',

	'home.regular.title': 'Düzenli gelir',
	'home.regular.reward.success': 'Başarıyla alındı',
	'home.regular.withdraw.success': 'Çekme işlemi başarılı',
	'home.regular.tips1': 'Kullanılabilir tutar',
	'home.regular.tips2': 'Gelir alabilirsiniz',
	'home.regular.tips3': 'FastToken geliri',
	'home.regular.btn1': 'Kurtar',
	'home.regular.btn2': 'Kazancınızı alın',

	'home.team.list.title1': 'Kişisel hareketlilik',
	'home.team.list.title2': 'Takım hareketliliği',
	'home.team.list.title3': 'Geçerli davetler',

	'home.state.order.tips.max': `Devam eden sipariş sayısı 25'i geçemez`,
	'home.message.tip10': 'Yetersiz mevduat tutarı',
}

export default home
